export default "__VITE_ASSET__DkpuluLm__"